// removed by extract-text-webpack-plugin
module.exports = {"list-item-box":"app-components-receipt-transactions-ListItemBox-__RefundListItemBox___QE4rR"};


//////////////////
// WEBPACK FOOTER
// ./app/components/receipt/transactions/ListItemBox/RefundListItemBox.css
// module id = 2023
// module chunks = 0